export default __webpack_public_path__ + "static/media/img4.705dea09.png";